/**
 * api-base — dev-only redirection of the picker's API endpoints to a local backend.
 *
 * When the storefront is served through `shopify theme dev` it runs on a
 * localhost origin (127.0.0.1:9292). Liquid can't detect that — it's rendered
 * server-side by Shopify on an ordinary development theme — but the browser can.
 * So on a localhost origin we rewrite each endpoint's scheme+host to a local API.
 *
 * This is guarded purely by the browser hostname, which is localhost ONLY under
 * theme dev (production and the theme editor both run on real Shopify hosts). So
 * it can never redirect the live storefront — and, crucially, even if the local
 * base below is accidentally committed it stays inert everywhere except localhost.
 *
 * Change LOCAL_API_BASE if your backend isn't on :5000.
 */

const LOCAL_HOSTS = new Set(['localhost', '127.0.0.1', '[::1]']);
const LOCAL_API_BASE = 'http://localhost:5000';

/**
 * Rewrite an endpoint's scheme+host to the local API on a localhost origin;
 * a no-op everywhere else. Plain origin substitution, so the `{sku}` token and
 * the path/query are left untouched (works on both the template and a built URL).
 *
 * @param {string} endpoint
 * @returns {string}
 */
export function localizeEndpoint(endpoint) {
  if (!endpoint || !LOCAL_HOSTS.has(window.location?.hostname)) return endpoint;
  return endpoint.replace(/^https?:\/\/[^/]+/i, LOCAL_API_BASE);
}
